import { FC } from 'react';
import { Modal } from 'antd';
import styled, { CSSProperties } from 'styled-components';

import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { Icon } from '@/shared/uikit/Icon';
import { useModalsStore } from '@/widgets/modals/modals.store';

import { ModalContainerProps } from '../ModalContainerV1';
import { ModalTitle } from '../ModalContainerV1/ModalTitle';

const DESKTOP_STYLES = {
  content: {
    minWidth: 600,
    maxHeight: 600,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    width: 'fit-content',
    maxWidth: 'fit-content',
  } as CSSProperties,
  body: {
    minWidth: 600,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
    width: '100%',
  } as CSSProperties,
  header: { margin: 0 },
};

const MOBILE_STYLES = {
  content: {
    padding: 0,
    borderRadius: 0,
    height: '100dvh',
    width: '100dvw',
    left: -8,
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  body: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  } as CSSProperties,
};

const MODAL_PROPS = {
  desktop: {
    centered: true,
    width: 'fit-content',
    styles: DESKTOP_STYLES,
  },
  mobile: {
    centered: true,
    width: '100dvw',
    height: '100dvh',
    style: { margin: 0 },
    styles: MOBILE_STYLES,
    closeIcon: false,
  },
};

export const ModalContainerV5: FC<ModalContainerProps> = ({ children, title }) => {
  const { closeModal } = useModalsStore();
  const isDesktop = useIsDesktop();

  const variant = isDesktop ? 'desktop' : 'mobile';

  return (
    <Modal
      open={true}
      onCancel={closeModal}
      onClose={closeModal}
      footer={null}
      title={isDesktop && <ModalTitle title={title} />}
      {...MODAL_PROPS[variant]}
    >
      {!isDesktop && (
        <>
          <HeadingContainer onClick={closeModal} style={{ cursor: 'pointer' }}>
            <Icon name="arrow-left" size="s20" />
            Back
          </HeadingContainer>
          <ModalTitle title={title} />
        </>
      )}
      {children}
    </Modal>
  );
};

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 26px 16px;
  font-weight: 700;
  cursor: pointer;
`;
